import { __read } from "tslib";
import { formatMessageCode } from "./formatMessageCode";
import { getFeatureIdFromMessageParams } from "./getFeatureNameFromMessageParams";
import { getMessageKeyFromNamespaceAndId } from "./getMessageKeyFromParams";
import { humaniseMessageType } from "./humaniseMessageType";
import { renderHumanReadableDebugText } from "./renderHumanReadableDebugText";
import { renderHumanReadableFeatureName } from "./renderHumanReadableFeatureName";
import { renderHumanReadableMessageName } from "./renderHumanReadableMessageName";
var parseMessageFromMessages = function (message, messages) {
    var _a = __read(message, 7), type = _a[0], timestamp = _a[1], packageNamespace = _a[2], featureNumber = _a[3], messageId = _a[4], args = _a[5], pinLifetime = _a[6];
    var debugText = renderHumanReadableDebugText(type, packageNamespace, featureNumber, messageId, args, messages);
    var code = formatMessageCode(packageNamespace, featureNumber, messageId);
    var featureName = renderHumanReadableFeatureName(packageNamespace, featureNumber, messages);
    var featureId = getFeatureIdFromMessageParams(packageNamespace, featureNumber, messages);
    var prefixedMessageKey = getMessageKeyFromNamespaceAndId(packageNamespace, featureNumber, messageId, messages);
    var messageName = renderHumanReadableMessageName(prefixedMessageKey);
    var severity = humaniseMessageType(type);
    return {
        args: args,
        timestamp: timestamp,
        type: type,
        packageNamespace: packageNamespace,
        featureNumber: featureNumber,
        featureId: featureId,
        messageId: messageId,
        pinLifetime: pinLifetime,
        debugText: debugText,
        code: code,
        featureName: featureName,
        messageName: messageName,
        severity: severity,
    };
};
export { parseMessageFromMessages };
//# sourceMappingURL=parseMessageFromMessages.js.map